function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useRef, useMemo, useCallback, Fragment, useEffect } from 'react';
import { componentsThemeMap, colorToVariable } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import '../../ui/RichText/index.js';
import { articleRichTextOptions } from '../../ui/RichText/options/articleRichTextOptions.js';
import '../../ui/Tabs/index.js';
import { Text } from '../../ui/Text.js';
import { HighlightTableScrollIndicator } from './HighlightTableScrollIndicator.js';
import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { RichText } from '../../ui/RichText/RichText.js';
import { Tabs } from '../../ui/Tabs/Tabs.js';

// Controls when the scroll indicator should be visible,
// where 0.1 is equal to 10% of the table width
const SCROLL_INDICATOR_THRESHOLD = 0.1;

// We need to cap the max width of the table columns when horizontal scrolling
// is enabled because the table cells are inside a grid container
const MOBILE_HORIZONTAL_SCROLL_COLUMN_WIDTH = 300;
function HighlightTable({
  headline,
  subhead,
  legalDisclaimer,
  data,
  columns,
  tabs = [],
  onRowClick: onRowClickProp,
  tableStyle = 'white',
  hasSpacingTop,
  hasMobileHorizontalScroll = false,
  anchor,
  style = 'default',
  hasSpacingHorizontal = true,
  fullViewportWidth = true
}) {
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  const _useState3 = useState({
      isLeftVisible: false,
      isRightVisible: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollIndicatorConfig = _useState4[0],
    setScrollIndicatorConfig = _useState4[1];
  const tableRef = useRef(null);
  const currentTabValue = tabs && tabs[currentTab];
  const rows = useMemo(() => {
    if (data.length === 0) return data;
    const _ref = currentTabValue || {},
      dataKey = _ref.dataKey,
      value = _ref.value,
      order = _ref.order,
      orderDataKey = _ref.orderDataKey,
      maxRows = _ref.maxRows;
    let filteredData = dataKey ? data.filter(entry => entry[dataKey] === value) : data;
    if (order) {
      const orderingKey = orderDataKey ?? dataKey;
      if (orderingKey) {
        const isAsc = order === 'asc';
        const sortFn = typeof data[0][orderingKey] === 'number' ?
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
        (a, b) => Number(a[orderingKey]) - Number(b[orderingKey]) :
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
        (a, b) => {
          const valueA = a[orderingKey] ?? '';
          const valueB = b[orderingKey] ?? '';
          return valueA.toString().localeCompare(valueB.toString());
        };
        const sortedData = [...filteredData].sort(sortFn);
        filteredData = isAsc ? sortedData : sortedData.reverse();
      }
    }
    if (maxRows) {
      filteredData = filteredData.slice(0, maxRows);
    }
    return filteredData;
  }, [data, currentTabValue]);
  const gridTemplateColumns = useMemo(() => {
    return {
      sm: columns.filter(column => !column.hideOnMobile).map(({
        size
      }) => `${size ? `minMax(min-content, ${size})` : '1fr'}`).join(' '),
      md: columns.map(({
        size
      }) => `${size ? `minMax(min-content, ${size})` : '1fr'}`).join(' ')
    };
  }, [columns]);
  const rowsData = useMemo(() => {
    return rows.map(row => {
      const columnsData = columns.map(({
        label,
        dataKey,
        subDataKey,
        color,
        hideOnMobile,
        verticalAlignment
      }) => ({
        label,
        data: dataKey && row[dataKey],
        subData: subDataKey && row[subDataKey],
        color,
        hideOnMobile,
        verticalAlignment
      }));
      return {
        onRowClick: onRowClickProp ? () => onRowClickProp(row) : undefined,
        columnsData
      };
    });
  }, [rows, columns, onRowClickProp]);
  const pillTabs = useMemo(() => {
    return tabs?.map(({
      label
    }, index) => ({
      id: index.toString(),
      label
    }));
  }, [tabs]);
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    background = _componentsThemeMap$s.background,
    backgroundAlternate = _componentsThemeMap$s.backgroundAlternate,
    backgroundHover = _componentsThemeMap$s.backgroundHover;
  const hasHeadingLabels = columns.some(c => c.label);
  const tableSpacingTop = subhead || headline || tabs.length > 0 ? 3 : 0;
  const onScroll = useCallback(target => {
    const scrollProgress = target.scrollLeft / (target.scrollWidth - target.clientWidth); // Scroll progress from 0 to 1

    setScrollIndicatorConfig({
      isLeftVisible: scrollProgress > SCROLL_INDICATOR_THRESHOLD,
      isRightVisible: scrollProgress < 1 - SCROLL_INDICATOR_THRESHOLD
    });
  }, []);

  // Rendering the table wrapper as a fragment if we don't need to handle the onScroll event
  const TableWrapper = hasMobileHorizontalScroll ? Div : Fragment;
  const tableWrapperProps = hasMobileHorizontalScroll ? {
    overflowX: 'auto',
    onScroll: event => onScroll(event.target),
    ref: tableRef,
    'data-qa': 'tableWrapper'
  } : {};

  // Triggering scroll handler manually to show the scroll indicators when the table is rendered
  useEffect(() => {
    if (hasMobileHorizontalScroll && tableRef.current) {
      onScroll(tableRef.current);
    }
  }, [hasMobileHorizontalScroll]);
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightTable",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        background: background,
        hasSpacingTop: hasSpacingTop,
        anchor: anchor,
        hasNonDefaultBackgroundSpacingVertical: fullViewportWidth,
        hasSpacingHorizontal: hasSpacingHorizontal,
        fullViewportWidth: fullViewportWidth,
        children: [headline && /*#__PURE__*/jsx(Text, {
          variant: {
            sm: 'title2',
            lg: 'display2'
          },
          as: "h2",
          color: foreground,
          children: headline
        }), subhead && /*#__PURE__*/jsx(Div, {
          flexDirection: "column",
          children: /*#__PURE__*/jsx(RichText, {
            content: subhead,
            color: foregroundSecondary,
            richTextOptions: articleRichTextOptions
          })
        }), tabs.length > 0 && /*#__PURE__*/jsx(Div, {
          spacingTop: {
            sm: 3,
            lg: 6
          },
          spacingBottom: {
            sm: 1,
            lg: 2
          },
          children: /*#__PURE__*/jsx(Tabs, {
            pillTabs: pillTabs
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
            ,

            onTabChange: id => setCurrentTab(Number(id) || 0),
            color: foreground
          })
        }), /*#__PURE__*/jsxs(Div, {
          position: "relative",
          overflow: "hidden",
          children: [hasMobileHorizontalScroll && /*#__PURE__*/jsx(HighlightTableScrollIndicator, {
            spacingTop: tableSpacingTop,
            style: style,
            isLeftIndicatorVisible: scrollIndicatorConfig.isLeftVisible,
            isRightIndicatorVisible: scrollIndicatorConfig.isRightVisible
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
            ,

            onButtonClick: direction => {
              const tableElement = tableRef.current;
              tableElement?.scrollTo({
                left: direction === 'left' ? 0 : tableElement?.scrollWidth,
                behavior: 'smooth'
              });
            }
          }), /*#__PURE__*/jsx(TableWrapper, _objectSpread(_objectSpread({}, tableWrapperProps), {}, {
            children: /*#__PURE__*/jsxs(Div, {
              as: "table",
              display: "grid",
              flex: {
                sm: hasMobileHorizontalScroll ? 'none' : 1,
                md: 1
              },
              maxWidth: {
                sm: hasMobileHorizontalScroll ? MOBILE_HORIZONTAL_SCROLL_COLUMN_WIDTH * columns.length : 'none',
                md: 'none'
              },
              gridTemplateColumns: gridTemplateColumns,
              spacingTop: tableSpacingTop,
              overflow: "auto",
              children: [hasHeadingLabels && /*#__PURE__*/jsx(Div, {
                as: "thead",
                display: "contents",
                children: /*#__PURE__*/jsx(Div, {
                  as: "tr",
                  display: "contents",
                  children: columns.map(({
                    label = '',
                    hideOnMobile
                  }, index) => /*#__PURE__*/jsx(Div, {
                    as: "td",
                    spacingHorizontal: {
                      sm: 1,
                      md: 2
                    },
                    spacingVertical: 2,
                    background: backgroundAlternate,
                    css: {
                      borderBottom: '1px solid'
                    },
                    borderColor: "lineHeavy",
                    display: {
                      sm: hideOnMobile ? 'none' : 'flex',
                      md: 'flex'
                    },
                    children: /*#__PURE__*/jsx(Text, {
                      variant: "label1",
                      overflow: "hidden",
                      color: foreground,
                      children: label
                    })
                  }, index))
                })
              }), /*#__PURE__*/jsx(Div, {
                as: "tbody",
                display: "contents",
                children: rowsData.map(({
                  onRowClick,
                  columnsData
                }, index) => /*#__PURE__*/jsx(Div, {
                  as: "tr",
                  display: "contents",
                  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
                  onClick: e => {
                    if (onRowClick) {
                      e.preventDefault();
                      onRowClick();
                    }
                  },
                  css: {
                    ':hover': onRowClick && {
                      '> td': {
                        background: colorToVariable(backgroundHover || 'primaryWash'),
                        cursor: 'pointer'
                      }
                    }
                  },
                  children: columnsData.map(({
                    label,
                    data,
                    subData,
                    color = foregroundSecondary,
                    hideOnMobile,
                    verticalAlignment = 'center'
                  }, columnIndex) => {
                    return /*#__PURE__*/jsx(Div, {
                      as: "td",
                      spacingHorizontal: {
                        sm: 1,
                        md: 2
                      },
                      spacingVertical: 2,
                      background: tableStyle === 'white' ? background : (index + (hasHeadingLabels ? 0 : 1)) % 2 ? backgroundAlternate : background,
                      alignItems: VERTICAL_ALIGNMENT_PROP_MAP[verticalAlignment],
                      display: {
                        sm: hideOnMobile ? 'none' : 'flex',
                        md: 'flex'
                      },
                      children: !data || typeof data === 'string' || typeof data === 'number' ? /*#__PURE__*/jsxs(Div, {
                        flex: 1,
                        gap: 1,
                        flexWrap: "wrap",
                        overflow: "hidden",
                        children: [data && /*#__PURE__*/jsx(Text, {
                          variant: "headline",
                          color: color,
                          children: /*#__PURE__*/jsx(Fragment$1, {
                            children: data
                          })
                        }), subData && /*#__PURE__*/jsx(Text, {
                          variant: "body",
                          color: color,
                          children: /*#__PURE__*/jsx(Fragment$1, {
                            children: subData
                          })
                        })]
                      }) : /*#__PURE__*/jsx(Fragment$1, {
                        children: data
                      })
                    }, `${label}-${columnIndex}`);
                  })
                }, `row-${index}`))
              })]
            })
          }), "tableWrapper")]
        }), legalDisclaimer && /*#__PURE__*/jsx(Text, {
          spacingTop: 5,
          variant: "legal",
          color: foregroundSecondary,
          as: "p",
          css: {
            whiteSpace: 'break-spaces'
          },
          children: legalDisclaimer
        })]
      })
    })
  });
}
const VERTICAL_ALIGNMENT_PROP_MAP = {
  top: 'baseline',
  bottom: 'end',
  center: 'center'
};
export { HighlightTable };
//# sourceMappingURL=HighlightTable.js.map
